import { Pipe, PipeTransform } from '@angular/core';
import { PlatformInfo, IPlatform } from '@root/config';

@Pipe({ name: 'thirdparty' })
export class ThirdpartyPipe implements PipeTransform {
  transform(value: number): IPlatform {
    return PlatformInfo[value] ? PlatformInfo[value] : { name: value };
  }
}
